import { withInstall } from '../../utils';
import IconSelect from './src/icon-select.vue';

export const IIconSelect = withInstall(IconSelect); // 增加类型

export default IIconSelect;
